import { createSelector } from 'reselect';
import { Set } from 'immutable';

// Constants
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

const getUserSuggestionsItems = state => state.userSuggestionItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getDayParam = createParameterSelector(params => params.day);
const getCompletedParam = createParameterSelector(params => params.completed);
const getDismissedParam = createParameterSelector(params => params.dismissed);

export const getAllUserSuggestions = createSelector([getUserSuggestionsItems], userSuggestions => {
  return userSuggestions.get(UserSuggestionsConstants.State.USER_SUGGESTIONS_BY_SLUG);
});

export const getUserSuggestionSlugsForDay = createSelector(
  [getUserSuggestionsItems, getDayParam],
  (userSuggestions, day) => {
    return userSuggestions.getIn([UserSuggestionsConstants.State.USER_SUGGESTIONS_SLUGS_BY_DAY, day], Set());
  }
);

export const getFilteredSuggestions = createSelector(
  [getAllUserSuggestions, getDismissedParam, getCompletedParam],
  (userSuggestions, dismissed, completed) => {
    let suggestions = userSuggestions;

    if (completed !== undefined) {
      suggestions = suggestions.filter(suggestion => {
        const isCompleted = suggestion.get('completed');
        return completed === isCompleted;
      });
    }

    if (dismissed !== undefined) {
      suggestions = suggestions.filter(suggestion => {
        const isDismissed = Boolean(suggestion.get('dismissedAt', null));
        return dismissed === isDismissed;
      });
    }

    return suggestions;
  }
);

export const getUserSuggestionsByDay = createSelector(
  [getFilteredSuggestions, getUserSuggestionSlugsForDay],
  (userSuggestions, slugsForDay) => {
    return (
      (userSuggestions
        .filter(userSuggestion => slugsForDay.includes(userSuggestion.get('slug')))
        .sortBy(userSuggestion => userSuggestion.get('completed'))
        .valueSeq()
        .toJS() as UserSuggestion[]) || ([] as UserSuggestion[])
    );
  }
);
